module.exports = {"341723100":"蓉城镇","341723101":"木镇镇","341723102":"庙前镇","341723103":"陵阳镇","341723104":"新河镇","341723105":"丁桥镇","341723106":"朱备镇","341723107":"杨田镇","341723108":"九华镇","341723109":"酉华镇","341723200":"乔木乡","341723202":"杜村乡","341723203":"九华乡","341723400":"青阳县开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341723.json
// module id = 1057
// module chunks = 0